<template>
  <div class="conteudoInterno" id="atividades">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Principais Atividades</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span :class="{ hideSeta: setaRightState }"><i class="right"></i></span></button>
      </div> 
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPurpleBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col23ponto5">
        </div>
        <div class="col66">
          <h4 class="h4Destaque">Prêmio UBC para <span class="ubcPurple sanukBlack">Rita Lee e Roberto de Carvalho</span></h4>

          <p class="top32">Em sua oitava edição, o Prêmio do Compositor Brasileiro foi entregue pela primeira vez a uma dupla de artistas: a paulistana Rita Lee e o carioca Roberto de Carvalho. No palco, a banda conduzida por Beto Lee, filho dos dois, reuniu nove artistas para celebrar a obra e a parceria de um casal que reinventou a música brasileira. <a href="https://www.youtube.com/watch?v=T3pSg_qGJZM" target='_blank'>Assista +</a></p>

          <div class="button top32">
            <button class="sanukBold" ></button>
          </div>
        
          <!-- <div class="hidden" v-show="value1">
            <p>Mais conteúdo?</p>
          </div>
          <div v-show="!value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Fechar  </span><div class="fechar"></div></button>
          </div> -->
          
          <h4 class="h4Destaque top50">Relatório <span class="ubcPurple sanukBlack">‘Por Elas Que Fazem a Música’ + SongCamp</span></h4>
          <p class="top32">Reforçando nosso compromisso com a equidade de gênero, lançamos mais uma edição do relatório Por Elas Que Fazem a Música, que há sete anos analisa a presença feminina na indústria com base no banco de dados da UBC. Como desdobramento, realizamos o primeiro SongCamp exclusivo para mulheres, no estúdio Sonastério, em Minas Gerais. O encontro resultou na criação e gravação da faixa “Deixa Florescer”, nascida de um processo colaborativo pautado por escuta, diversidade e liberdade criativa. <a href="https://www.canva.com/design/DAF7S0KsTB0/HOoObAjw_80Hf_PKgTyRxw/view?utm_content=DAF7S0KsTB0&utm_campaign=designshare&utm_medium=link&utm_source=editor#1%25C2%25A0" target='_blank'>Leia +</a> <a href="https://www.youtube.com/watch?v=1ju2USTNi6Q&list=PLK2i8iPUlTrJL2IywtRlrlh6MZygP6eqg" target='_blank'>Veja +</a></p>

          <div class="button top32">
            <button class="sanukBold" ></button>
          </div>

          <!-- <div class="hidden" v-show="value2">
            <p>Mais conteúdo?</p>            
          </div>
          <div v-show="!value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Fechar </span><div class="fechar"></div></button>
          </div> -->

          <h4 class="h4Destaque top50">Tradições UBC em homenagem à <span class="ubcPurple sanukBlack">Alaíde Costa</span></h4>

          <p class="top32">Reverenciando a música brasileira e valorizando seus protagonistas, a UBC criou, em 2021, o Troféu Tradições. A premiação celebra grandes movimentos culturais e seus representantes. Desde então, tem homenageado figuras femininas de destaque, reconhecendo suas sonoridades autênticas e atemporais. Em 2024, a grande homenageada foi a “estilista da MPB”, Alaíde Costa. <a href="https://www.youtube.com/watch?v=xMBxgHiU2T0&list=PLK2i8iPUlTrLvZk2DTm9Aqo4yPscrFu_D" target='_blank'>Confira +</a></p>

          <div class="button top32">
            <button class="sanukBold" ></button>
          </div>

          <h4 class="h4Destaque top50">Podcast <span class="ubcPurple sanukBlack">Palavra de Autor</span></h4>

          <p class="top32">Original da UBC, o projeto estreou em 2024 mergulhando no universo da composição e revelando os bastidores e emoções por trás de grandes canções. Gravado na Casa UBC, no Rio de Janeiro, e conduzido por Celso Fonseca, o programa combinou conversas descontraídas com compositores e momentos de interpretações ao vivo. <a href="https://www.youtube.com/watch?v=pBGxEMJ2g8Q&list=PLK2i8iPUlTrIbH89ou6JBclfLcOIF1N7X" target='_blank'>Veja +</a></p>

          <div class="button top32">
            <button class="sanukBold" ></button>
          </div>

          <h4 class="h4Destaque top50">Medalha UBC para <span class="ubcPurple sanukBlack">Fausto Nilo</span></h4>

          <p class="top32">No último ano, a UBC lançou também a Medalha UBC, criada para reconhecer trajetórias que marcaram a música brasileira. O primeiro homenageado foi o letrista cearense Fausto Nilo, celebrado por sua contribuição à canção popular. Com mais de 300 composições e 800 gravações, foi reverenciado em uma noite em Fortaleza marcada por emoção, encontros e música ao vivo. Um tributo à força poética de sua obra e à criação musical nordestina. <a href="https://www.ubc.org.br/publicacoes/noticia/22819/em-noite-historica-fausto-nilo-e-o-primeiro-a-receber-a-medalha-ubc" target='_blank'>Leia +</a></p>

          <div class="button top32">
            <button class="sanukBold" ></button>
          </div>

          <h4 class="h4Destaque top50"><span class="ubcPurple sanukBlack">UBC Jam</span> por todo o Brasil</h4>

          <p class="top32">Já consolidada no calendário da cena musical, a iniciativa segue ampliando sua presença pelo Brasil com edições em São Paulo, Rio de Janeiro, Recife, Belo Horizonte e Salvador. Na capital baiana, ganhou um significado especial ao celebrar os 25 anos da UBC Bahia com uma edição histórica que promoveu encontros entre gerações, gêneros e experiências. <a href="https://www.ubc.org.br/publicacoes/noticia/22575/salvador-recebe-edicao-especial-da-ubc-jam-em-comemoracao-aos-25-anos-da-ubc-bahia" target='_blank'>Saiba +</a></p>

        </div>
      </section>
    </div>
  </div>
  </template>
  
  <script>
  import { ShareFunctions } from "../assets/js/functions.js";

  export default {
    name: 'AtividadesPrincipais',
    props:['clicked'],
  
    data() {
      return{
        setaScrollState: false,
        setaRightState: false,
        value1: false,
        value2: false,
      }
    },
    mounted() {

      const conteudo = document.querySelector("#atividades");
      conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    },
    created(){
      this.hideSetaFunc();
    },
    methods: {

      hideSetaFunc: function(){
      let route = this.$route.path;
      if (route === "/AtividadesPrincipais") {
          this.setaRightState = true
        } else { 
          this.setaRightState = false
        }    
      },
      goNext: function(){
        this.$emit("go-next");
      },
      goBack: function(){
        this.$emit("go-back");
      }, 
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

    p a {
      color: #8781D1;
      font-family: 'sanuk-bold';
    }
    .button {
      width: 100%;
      border-bottom: 1px solid #8781D1;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 32px;
    }
    button {
      color: #8781D1;
      cursor: pointer;
      padding-bottom: 4px;
      display: flex;
    }
    .hidden {
      opacity: 1;
      max-height: auto;
      overflow: hidden;
      animation: open .75s ease-in; 
    }
    @keyframes open {
        0%   {max-height: 0; opacity: 0;}
        100% {max-height: 2000px; opacity: 1;}
      }
    .leiaMais::before, .leiaMais::after, .fechar::before, .fechar::after {
      content: '';
      position:absolute;
      background-color: #8781D1;
      transition: transform 0.25s ease-out;
    }
    .leiaMais{
      position: relative;
      width: 15px;
      height: 15px;
      margin-left: 10px
    }
    .leiaMais::before {
      top: 0;
      left:Calc(50% - 1.5px);;
      width: 3px;
      height: 100%;
    }
    .leiaMais::after{
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top: -1.5px;
    }
    .fechar{
      position: relative;
      width: 15px;
      height: 15px;
      margin-left: 10px
    }
    .fechar::before {
      top: 0;
      left: Calc(50% - 1.5px);;
      width: 3px;
      height: 100%;
      margin-left: -1.5px;
      transform: rotate(90deg);
    }
    .fechar::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top: -1.5px;
    }

  </style>
